import api from '@/services/AxiosConfig';
const { CITY_URL = 'dropdown/get-provinces', ADVISOr_URL = 'dropdown/get-user-advisors' } = {};
export class HelperService {
  static getCity() {
    return api
      .get(`${CITY_URL}`)
      .then((res) => res.data?.map((m) => ({ text: m.nameEn, value: m.id })) || [])
      .catch((er) => {
        return [];
      });
  }

  static getAdvisor() {
    return api
      .get(`${ADVISOr_URL}`)
      .then((res) => res.data?.map((m) => ({ text: m.name, value: m.id })) || [])
      .catch((er) => {
        return [];
      });
  }

  static formatCurrency(value, symbol = true) {
    if (typeof value !== 'number') {
      return '';
    }
    const currencyValue = value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    if (!symbol) return currencyValue?.replace('$', '');
    return currencyValue;
  }
  toFixedTruncate(value, decimals = 2) {
    const factor = Math.pow(10, decimals);
    return Math.trunc(value * factor) / factor;
  }

  static toFixedTruncateStr(value, decimals = 2) {
    return +new HelperService().toFixedTruncate(value, decimals).toFixed(decimals);
  }

  static formatCurrency3Degit(value, locale = 'en-US', currency = 'USD') {
    if (typeof value !== 'number') {
      console.warn('Value passed to formatCurrency is not a number.');
      return value;
    }
  }
  static getCurrency(value) {
    return value.toString().replace(/,/g, '');
  }
}
